import './styles.scss'

import React from 'react'
import I18n from 'lib/i18n'
import { useValues, useActions } from 'kea'

import Img from 'lib/tags/img'

import logic from './logic'

const PORTAL_GRID_ITEMS = [
  {
    imageSource: 'owl-glass',
    title: 'find_title',
    text: 'find_text'
  },
  {
    imageSource: 'owl-message',
    title: 'communicate_title',
    text: 'communicate_text'
  },
  {
    imageSource: 'owl-calendar',
    title: 'book_title',
    text: 'book_text'
  }
]

const PortalContent = React.forwardRef((props, ref) => {
  const { howItWorksLink } = useValues(logic)
  const { hideHow } = useActions(logic)

  const handleClose = event => {
    event.preventDefault()
    hideHow()
  }

  return (
    <div id='homepage-how' ref={ref}>
      <a className='close' href='#' onClick={handleClose}>
        <Img src='/assets/design2/home/how/close.webp' alt='close' />
      </a>
      <div className='grid'>
        <div className='col-1-1'>
          <h1>{I18n.t('react.homepage.how.title')}</h1>
        </div>
      </div>
      <div className='grid-768 small-wide'>
        {PORTAL_GRID_ITEMS.map((item, index) => (
          <div key={index} className='col-1-3'>
            <Img className='owl' src={`/assets/design2/home/how/${item.imageSource}.webp`} alt={item.imageSource} />
            <h2>{I18n.t(`react.homepage.how.${item.title}`)}</h2>
            <p>{I18n.t(`react.homepage.how.${item.text}`)}</p>
          </div>
        ))}
      </div>
      <div className='grid'>
        <div className='col-1-1'>
          <small
            dangerouslySetInnerHTML={{
              __html: I18n.t('react.homepage.how.small_print_with_url', { url: howItWorksLink })
            }}
          />
        </div>
      </div>
    </div>
  )
})

export default PortalContent
